export default "__VITE_ASSET__d775c14e__"